// extracted by mini-css-extract-plugin
export default {"wrapperStyle":"AppletNavigationLog_wrapperStyle__-DxWC"};